
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { SamplePoService } from "./sample-po.service";
import { samplePoOrdersDto } from "./dto/sample-po-orders.dto";
import { SamplecoLineDto } from "./dto/sample-co-line.dto";



@ApiTags("/sample_po")
@Controller("/sample_po")
export class SamplePoController {

    constructor(
        private readonly Service: SamplePoService,
        private readonly applicationExeptionhandler: ApplicationExceptionHandler

    ) { }

    @ApiBody({ type: samplePoOrdersDto })
    @Post('/OrdersSaveData')
    async OrdersSaveData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return this.Service.OrdersSaveData(req, false);
        } catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err);
        }
    }

    @Post('/updateOrder')
    @ApiBody({ type: samplePoOrdersDto })
    async updateOrder(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.OrdersSaveData(req, true)
    }


    @Post('/saveExcelInfo')
    async saveExcelInfo(@Body() data: any): Promise<CommonResponseModel> {
        try {
            return this.Service.saveExcelInfo(data);
        } catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err);
        }
    }

    @Post('/getColorInfo')
    async getColorInfo(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return this.Service.getColorInfo(req);
        } catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err);
        }
    }


    @Post('/createCOline')
    async createCOline(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.createCOline(req)
        } catch (error) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, error)
        }
    }

    @Post('/getSampleOrderAcceptanceData')
    async getSampleOrderAcceptanceData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getSampleOrderAcceptanceData(req)
        } catch (error) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, error)
        }
    }



    @Post('/getOrders')
    @ApiBody({ type: samplePoOrdersDto })
    async getOrders(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getOrders()
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    @Post('/getAllOrdersDetails')
    async getAllOrdersDetails(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllOrdersDetails()
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    
    @Post('/createCoLineData')
    @ApiBody({ type: SamplecoLineDto })
    async createCoLineData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.createCoLineData(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    
    @Post('/getColineData')
    async getColineData(@Body() req: any): Promise<CommonResponseModel> {
        console.log(req,"testcontrrr")
        try {
            return await this.Service.getColineData(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }
    
    @Post('/getDistinctPoNumber')
    async getDistinctPoNumber(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getDistinctPoNumber()
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    @Post('/getDistinctBuyerCode')
    async getDistinctBuyerCode(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getDistinctBuyerCode()
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    @Post('/getDistinctBuyerStyle')
    async getDistinctBuyerStyle(req:any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getDistinctBuyerStyle(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    @Post('/updateItemNo')
    async updateItemNo(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateItemNo(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    @Post('/deleteCoLine')
    async deleteCoLine(@Body() req ?: any): Promise<CommonResponseModel> {
        console.log("controller",req)
        try {
            return await this.Service.deleteCoLine(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

    // @Post('/updateStatusInOrder')
    // async updateStatusInOrder(@Body() req: any): Promise<CommonResponseModel> {
    //     try {
    //         return await this.Service.updateStatusInOrder(req)
    //     }
    //     catch (err) {
    //         return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
    //     }
    // }

    @Post('/getCoLineDataAndSendEmail')
    async getCoLineDataAndSendEmail(@Body() req ?: any): Promise<CommonResponseModel> {
        console.log("controller",req)
        try {
            return await this.Service.getCoLineDataAndSendEmail(req)
        }
        catch (err) {
            return this.applicationExeptionhandler.returnException(CommonResponseModel, err)
        }
    }

}